module.exports = __webpack_public_path__ + "static/media/10101.28988c60.mp3";